import { Button, Flex } from '@grubhubprod/gh-cookbook-react';
import React from 'react';
import { useScreenSizes } from 'src/utilities/useScreenSizes';

const GROUP_ORDERS_HREF =
  'https://corporate.grubhub.com/resource/how-to-place-a-group-order-admin/?page=Resource+-+How+to+place+a+group+order+admin';

export function GroupOrdersAction(): JSX.Element {
  const { isPhone } = useScreenSizes();

  return (
    <Button
      variant="secondary"
      buttonSize="medium"
      block={isPhone}
      target="_blank"
      as="a"
      href={GROUP_ORDERS_HREF}
    >
      {/* TODO: Remove after Cookbook bug is fixed (block=true&as=a is broken) */}
      <Flex justifyContent="center">Learn more</Flex>
    </Button>
  );
}
